<template>
  <div class="bottom">
    <div class="container flex_column">
      <div class="content flex_row">
        <div class="left flex_column">
          <img src="@/assets/img/icon_logo.png" alt="">
          <div class="title">中视觉健康科技（广州）有限责任公司</div>
          <div class="info">VISION INTELLIGENT SYSTEM UNION MALL</div>
        </div>
        <div class="center">
          <div class="content_top flex_row">
            <div class="title">联系我们</div>
            <div class="info">Contact us</div>
          </div>
          <div class="content_body flex_row">
            <div class="left">
              <div class="icon flex_row">
                <img src="@/assets/img/icon_mailbox.png" alt="">
                <div>louischen@visumall.com</div>
              </div>
              <div class="icon flex_row">
                <img src="@/assets/img/icon_address.png" alt="">
                <div>中国·中视觉健康科技（广州）有限责任公司</div>
              </div>
              <div class="icon flex_row">
                <img src="@/assets/img/icon_phone.png" alt="">
                <div>+86 13728031869</div>
              </div>
              <div class="icon flex_row">
                <img src="@/assets/img/icon_location.png" alt="">
                <div>广州市海珠区敦和路171号</div>
              </div>
            </div>
            <div class="right">
              <div class="icon flex_row">
                <img src="@/assets/img/icon_mailbox.png" alt="">
                <div>louischen@visumall.com</div>
              </div>
              <div class="icon flex_row">
                <img src="@/assets/img/icon_address.png" alt="">
                <div>VISUMALL TECHONLOGY</div>
              </div>
              <div class="icon flex_row">
                <img src="@/assets/img/icon_phone.png" alt="">
                <div>+1 626-956-0918</div>
              </div>
              <div class="icon flex_row">
                <img src="@/assets/img/icon_location.png" alt="">
                <div>9040 TELSTARAVE STE 105,EL MONTE,CA 91731,USA</div>
              </div>
            </div>
          </div>
        </div>
        <div class="right flex_column">
          <img src="@/assets/img/icon_code.jpg" alt="">
          <div class="info">VISUMALL官方公众号</div>
        </div>
      </div>
      <div class="footer flex_row">
        <div class="left">中视觉健康科技（广州）有限责任公司版权所有</div>
        <div class="right"><a href="https://beian.miit.gov.cn" target="_blank" style="color: #fff;text-decoration: none">粤ICP备16100750号-3</a></div>
      </div>
    </div>
    <div class="back">
      <img src="@/assets/img/bottom.jpg" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "bottom",
  data() {
    return {
    }
  },
}
</script>

<style scoped lang="scss">
@media screen and (min-width: 1400px) {
  .bottom {
    width: 90vw;
    margin: auto;
  }
}
.bottom {
  //margin-top: 0.13rem;
  position: relative;
  .back {
    //position: relative;
    z-index: -1;
    width: 100%;
    img {
      width: 100%;
    }
  }
  .container {
    position: absolute;
    color: #FFFFFF;
    height: 100%;
    width: 100%;
    .content {
      width: 100%;
      height: 85%;
      background: rgba(0,0,0,0.3);
      .left {
        width: 22.5%;
        height: 100%;
        img {
          width: 50%;
        }
        .title {
          margin-top: 0.13rem;;
          //font-size: 0.16rem;
          font-size: 100%;
        }
        .info {
          margin-top: 0.05rem;
          //font-size: 0.14rem;
          font-size: 100%;
        }

      }
      .center {
        flex: 1;
        padding: 0.5rem;
        .content_top {
          justify-content: flex-start;
          //padding-bottom: 0.25rem;;
          padding-bottom: 1.5%;
          border-bottom: 0.01px solid #FFFFFF;
          .title {
            //font-size: 0.18rem;
            font-size: 120%;
          }
          .info {
            //font-size: 0.12rem;
            font-size: 90%;
            margin-left: 0.11rem;;
          }
        }
        .content_body {
          justify-content: flex-start;
          .left, .right {
            flex: 1;
            .icon {
              justify-content: flex-start;
              //margin-top: 0.32rem;
              margin-top: 6%;
              text-align: left;
              img {
                width: 0.22rem;
                height: 0.22rem;
              }
              div {
                margin-left: 0.11rem;
                //font-size: 0.14rem;
                font-size: 100%;
              }
            }
          }
          .right {
            div {
              margin-left: 0.11rem;
              //font-size: 0.14rem;
              font-size: 100%;
            }
          }

        }
      }
      .right {
        width: 18%;
        img {
          width: 50%;
        }
        .info {
          margin-top: 0.16rem;
          font-size: 0.16rem;
        }
      }
    }
    .footer {
      height: 15%;
      line-height: 15%;
      //margin-top: 0.2rem;
      .left {
        //font-size: 0.14rem;
        font-size: 100%;
      }
      .right {
        margin-left: 0.12rem;
        //font-size: 0.12rem;
        font-size: 100%;
      }
    }
  }
}
</style>
